import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const endpoints = {
  dashboard: () => api.get("/dashboard").then((r) => r.data),
  evidence: () => api.get("/evidence").then((r) => r.data),
  participants: () => api.get("/participants").then((r) => r.data),
  participant: (id) => api.get(`/participants/${id}`).then((r) => r.data),
  createParticipant: (data) => api.post("/participants", data).then((r) => r.data),
  updateParticipant: (id, data) => api.put(`/participants/${id}`, data).then((r) => r.data),
  deleteParticipant: (id) => api.delete(`/participants/${id}`).then((r) => r.data),
  commitments: (params = {}) => api.get("/commitments", { params }).then((r) => r.data),
  markCommitment: (id, data) => api.post(`/commitments/${id}/mark`, data).then((r) => r.data),
  resetCommitment: (id) => api.post(`/commitments/${id}/reset`).then((r) => r.data),
  createActivity: (data) => api.post("/activities", data).then((r) => r.data),
  resolveActivity: (id, resolution) =>
    api.post(`/activities/${id}/resolve`, { resolution }).then((r) => r.data),
  deleteActivity: (id) => api.delete(`/activities/${id}`).then((r) => r.data),
  reseed: () => api.post("/seed", null, { params: { force: true } }).then((r) => r.data),
  exportCsvUrl: () => `${API}/export/participants.csv`,
};
